import React from 'react'

const Jewellry = () => {
  return (
    <iframe scrolling="yes" width="100%" height="3600px" frameborder="0" sandbox="allow-scripts allow-forms allow-same-origin" src="https://morgantaylor-frame-categoryembed.jewelershowcase.com/browse/jewelry"></iframe>
  )
}

export default Jewellry
